export default "__VITE_ASSET__b2f98ea1__"